export { default } from './HubHero';



// WEBPACK FOOTER //
// ./src/components/templates/HubHero/index.js